import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const portfolioItems = [{
  id: 1,
  img: 'https://images.unsplash.com/photo-1530103862676-de8892ebeea0?q=80&w=2070&auto=format&fit=crop',
  aspect: 'aspect-[3/4]',
  title: "Gala Dinner '23"
}, {
  id: 2,
  img: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?q=80&w=2069&auto=format&fit=crop',
  aspect: 'aspect-square',
  title: 'Tech Summit'
}, {
  id: 3,
  img: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=2069&auto=format&fit=crop',
  aspect: 'aspect-[4/3]',
  title: 'Private Wedding'
}, {
  id: 4,
  img: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?q=80&w=2070&auto=format&fit=crop',
  aspect: 'aspect-[3/4]',
  title: 'Fashion Week Afterparty'
}, {
  id: 5,
  img: 'https://images.unsplash.com/photo-1505236858219-8359eb29e329?q=80&w=2162&auto=format&fit=crop',
  aspect: 'aspect-square',
  title: 'Brand Launch'
}];
export function Portfolio() {
  return <section id="portfolio" className="py-32 bg-background relative" data-id="element-128">
      <div className="container mx-auto px-6 md:px-12" data-id="element-129">
        <motion.div className="text-center mb-20" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-130">
          <h2 className="text-gold uppercase tracking-[0.2em] text-sm font-sans mb-4" data-id="element-131">
            Вибрані роботи
          </h2>
          <h3 className="text-4xl md:text-6xl font-serif text-ivory" data-id="element-132">
            Портфоліо
          </h3>
        </motion.div>

        {/* Masonry Grid using Columns */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-133">
          {portfolioItems.map((item, index) => <motion.div key={item.id} className="break-inside-avoid group relative overflow-hidden cursor-none" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index % 3 * 0.1
        }} data-id="element-134">
              <div className={`${item.aspect} w-full relative overflow-hidden bg-surface`} data-id="element-135">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-[1.5s] ease-[cubic-bezier(0.25,1,0.5,1)]" loading="lazy" data-id="element-136" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-8" data-id="element-137">
                  <h4 className="text-xl font-serif text-ivory transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-138">
                    {item.title}
                  </h4>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-20 text-center" data-id="element-139">
          <a href="#" className="inline-block border-b border-gold text-gold uppercase tracking-widest text-sm pb-1 hover:text-ivory hover:border-ivory transition-colors duration-300" data-id="element-140">
            Переглянути всі проекти
          </a>
        </div>
      </div>
    </section>;
}